import { render, staticRenderFns } from "./CampaignMassRequestConsentZalo.vue?vue&type=template&id=b735c4f0&scoped=true&"
import script from "./CampaignMassRequestConsentZalo.vue?vue&type=script&lang=js&"
export * from "./CampaignMassRequestConsentZalo.vue?vue&type=script&lang=js&"
import style0 from "./CampaignMassRequestConsentZalo.vue?vue&type=style&index=0&id=b735c4f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b735c4f0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardActions } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
import { VForm } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSelect } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VCard,
  VCardActions,
  VCardText,
  VCardTitle,
  VDataTable,
  VDialog,
  VDivider,
  VForm,
  VIcon,
  VLayout,
  VSelect,
  VSpacer,
})
